export const GET_PAYMENT_DATA="GET_PAYMENT_DATA"
export const SET_PAYMENT_DATA="SET_PAYMENT_DATA"
export const GET_CONFIGURATION_DATA="GET_CONFIGURATION_DATA"
export const GET_SELLER_PROFILE_DATA="GET_SELLER_PROFILE_DATA"